<template>
  <div>
    <input type="file" accept="image/*" id="stepFile"  capture="camera" @change="photoFun"/>
  </div>
</template>

<script>
  export default {
    name: "Home",
    created: function () {},
    computed: {},
    methods: {
      //调用相机
      photoFun(){
        alert(1);
      }
    }
  };
</script>